import axios from "axios";

/**
 * Gets the free-albums configuration through the SUF backend proxy.
 *
 * @returns {Promise<Array<Object>>} Free-albums configuration entries.
 */
export async function GetFreeAlbumsConfiguration() {
    const response = await axios.get("/api/GetFreeAlbumsConfiguration");

    return Array.isArray(response.data) ? response.data : [];
}
